import { render, staticRenderFns } from "./ModalCustomerOrder.vue?vue&type=template&id=0d84c472"
import script from "./ModalCustomerOrder.vue?vue&type=script&lang=js"
export * from "./ModalCustomerOrder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports